export function oauthStartUrl(provider) {
  if (!new Set(["google", "microsoft"]).has(provider)) {
    throw new Error("Unsupported login provider");
  }
  const backend = process.env.REACT_APP_BACKEND_URL;
  if (!backend) {
    throw new Error("REACT_APP_BACKEND_URL is not set");
  }
  return `${backend.replace(/\/$/, "")}/api/auth/${provider}/start`;
}
